module.exports = __webpack_public_path__ + "img/watercare.894238ad.png";